import { useTeachingCourses } from "@/hooks/use-teaching-courses";
import type { NavGroup } from "@/navigation/sidebar-items";
import { CourseSeatNavigation } from "./CourseSeatNavigation";

export function TeachingNavigation({ group }: { group: NavGroup }) {
  const query = useTeachingCourses();
  return <CourseSeatNavigation group={group} query={query} capacityLabel="Teaching" hideNoSeat={group.id === "admin-teaching"} />;
}
